<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="营业概况" name="finance-income"></el-tab-pane>
      <el-tab-pane label="项目销售收入" name="finance-performance"></el-tab-pane>
      <el-tab-pane label="产品销售收入" name="finance-report"></el-tab-pane>
      <el-tab-pane label="套餐销售收入" name="finance-statistics"></el-tab-pane>
      <el-tab-pane label="快捷收银收入" name="finance-sale"></el-tab-pane>
    </el-tabs>
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  data() {
    return {
      activeName: 'finance-income'
    };
  },
  watch: {
    $route(e) {
      this.activeName = e.name;
    },
    activeName() {
      const vm = this;
      this.$router.push({
        name: vm.activeName
      });
    }
  },
  activated() {
    this.activeName = this.$route.name;
  }
};
</script>
